import React from "react";
import {
  Box,
  Link,
  ListItem,
  OrderedList,
  Text,
  UnorderedList
} from "@chakra-ui/react";
import { INLINES, BLOCKS, MARKS } from "@contentful/rich-text-types";

export const options = {
  renderMark: {
    // eslint-disable-next-line
    [MARKS.CODE]: (text: any) => (
      <Box
        display="inline"
        bg="gray.900"
        borderRadius="md"
        paddingY="0.25rem"
        paddingX="0.5rem"
        width="fit-content"
        fontWeight="bold"
      >
        <Text as="kbd" fontWeight="bold">
          {text}
        </Text>
      </Box>
    )
  },
  renderNode: {
    // eslint-disable-next-line
    [BLOCKS.HEADING_1]: (node: any, children: any) => (
      <Text fontSize="4xl" marginBottom="0.5rem">
        {children}
      </Text>
    ),
    // eslint-disable-next-line
    [BLOCKS.HEADING_2]: (node: any, children: any) => (
      <Text fontSize="3xl" marginBottom="0.5rem">
        {children}
      </Text>
    ),
    // eslint-disable-next-line
    [BLOCKS.HEADING_3]: (node: any, children: any) => (
      <Text fontSize="2xl" marginBottom="0.5rem">
        {children}
      </Text>
    ),
    // eslint-disable-next-line
    [BLOCKS.HEADING_4]: (node: any, children: any) => (
      <Text fontSize="xl" marginBottom="0.5rem">
        {children}
      </Text>
    ),
    // eslint-disable-next-line
    [BLOCKS.HEADING_5]: (node: any, children: any) => (
      <Text fontSize="lg" marginBottom="0.5rem">
        {children}
      </Text>
    ),
    // eslint-disable-next-line
    [BLOCKS.HEADING_6]: (node: any, children: any) => (
      <Text fontSize="md" marginBottom="0.5rem">
        {children}
      </Text>
    ),
    // eslint-disable-next-line
    [BLOCKS.PARAGRAPH]: (node: any, children: any) => (
      <Text marginBottom="0.5rem">{children}</Text>
    ),
    // eslint-disable-next-line
    [BLOCKS.UL_LIST]: (node: any, children: any) => (
      <UnorderedList marginLeft="1rem" spacing={1}>
        {children}
      </UnorderedList>
    ),
    // eslint-disable-next-line
    [BLOCKS.OL_LIST]: (node: any, children: any) => (
      <OrderedList marginLeft="1rem" spacing={1}>
        {children}
      </OrderedList>
    ),
    // eslint-disable-next-line
    [BLOCKS.LIST_ITEM]: (node: any, children: any) => (
      <ListItem>{children}</ListItem>
    ),
    // eslint-disable-next-line
    [INLINES.HYPERLINK]: (node: any, children: any) => (
      <Link
        as="a"
        href={node.data.uri}
        textDecoration="underline"
        _hover={{ color: "black" }}
      >
        {children}
      </Link>
    )
  }
};
